import React from "react";
type ContextProps = {
  activeFirmwareVersion: string;
  setActiveFirmwareVersion: React.Dispatch<React.SetStateAction<string>>;
  activeHardwareVersion: string;
  setActiveHardwareVersion: React.Dispatch<React.SetStateAction<string>>;
};
const Context = React.createContext<ContextProps | undefined>(undefined);
type ProviderProps = {
  initialFirmwareVersion: string;
  initialHardwareVersion: string;
  children: React.ReactNode;
};
export const DownloadsProvider = (props: ProviderProps) => {
  const {
    children,
    initialFirmwareVersion,
    initialHardwareVersion
  } = props;
  const [activeFirmwareVersion, setActiveFirmwareVersion] = React.useState(initialFirmwareVersion);
  const [activeHardwareVersion, setActiveHardwareVersion] = React.useState(initialHardwareVersion);
  const value = {
    activeFirmwareVersion,
    setActiveFirmwareVersion,
    activeHardwareVersion,
    setActiveHardwareVersion
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
};
export const useDownloads = (): ContextProps => {
  const context = React.useContext(Context);
  if (context === undefined) {
    throw new Error("useDownloads must be used within a DownloadsProvider");
  }
  return context;
};